import { assignKey } from "../assignKey";

/**
 * Assign second object keys to first
 */
export const assignKeys = (
	target: Record<string | symbol, any>,
	source: Record<string | symbol, any>,
): void => Object.keys(source).forEach((key) => assignKey(target, source, key));
